if (typeof ModalDialog !== 'undefined' && !customElements.get('product-modal')) {
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      this.openedBy = opener;
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      if (!this.openedBy) return;

      const mediaId = this.openedBy.getAttribute('data-media-id');
      if (!mediaId) return;

      // Disattiva tutti i media non attivi
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`)
        .forEach((el) => el.classList.remove('active'));

      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
      if (!activeMedia) return;

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate?.content;

      activeMedia.classList.add('active');
      activeMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const container = this.querySelector('[role="document"]');
      if (container && activeMedia?.width && container.clientWidth) {
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      }

      // Se è un YouTube video, caricalo solo se richiesto
      if (
        activeMedia.nodeName === 'DEFERRED-MEDIA' &&
        activeMediaContent?.querySelector('.js-youtube')
      ) {
        activeMedia.loadContent?.();
      }
    }
  }

  customElements.define('product-modal', ProductModal);
} else {
  console.warn('❗️ModalDialog non è definito oppure "product-modal" è già stato registrato.');
}
